import { render, staticRenderFns } from "./IconNavSave.vue?vue&type=template&id=c5590ff4&scoped=true&"
var script = {}
import style0 from "./IconNavSave.vue?vue&type=style&index=0&id=c5590ff4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5590ff4",
  null
  
)

export default component.exports